import classnames from "classnames";
import React from "react";
import { SanityImage, SanityRawContent } from "../../model/common";
import { imageUrlBuilder } from "../../utils/images";
import { Col, Row } from "../Grid";
import LandingPageSectionCard from "../LandingPageSectionCard/LandingPageSectionCard";
import styles from "./LogoImageBlock.module.scss";
import MicrobitFaceIcon from "../../icons/MicrobitFaceIcon";

interface LogoImageBlockProps {
  image: SanityImage;
  content: SanityRawContent;
  dir?: "ltr" | "rtl";
}

const LogoImageBlock = ({ content, image, dir }: LogoImageBlockProps) => {
  // We end up needing this in the DOM twice as it needs different parents
  // to get the correct mobile (flow) and desktop (absolute) positionings.
  const img = (
    <img
      alt={image.alt}
      loading="lazy"
      src={
        imageUrlBuilder
          .image(image)
          .ignoreImageParams()
          .width(991) // for mobile, could do smaller for desktop
          .url()!
      }
    />
  );
  return (
    <>
      <Row className={styles.gradient} dir={dir}>
        <div className={styles.contentWrapper}>
          <LandingPageSectionCard
            preamble={
              <>
                <div className={styles.face}>
                  <MicrobitFaceIcon />
                </div>
                <div
                  className={classnames(styles.image, styles.shownOnDesktop)}
                  dir={dir}
                >
                  {img}
                </div>
              </>
            }
            className={styles.content}
            content={content}
          />
        </div>
      </Row>
      <Row dir={dir}>
        <Col
          className={classnames(styles.image, styles.shownOnTabletOrBelow)}
          md={12}
          xs={12}
        >
          {img}
        </Col>
      </Row>
    </>
  );
};

export default LogoImageBlock;
